import { render, staticRenderFns } from "./SuggestedListing.vue?vue&type=template&id=24d6df5b&scoped=true&"
import script from "./SuggestedListing.vue?vue&type=script&lang=ts&"
export * from "./SuggestedListing.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedListing.vue?vue&type=style&index=0&id=24d6df5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6df5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCardTitle,VImg})
